import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconUnlimitedProps } from './IconUnlimited.types'
import * as Styled from './styles/IconUnlimited.style'

import { nonThemeableRules } from '../../ruleSet'

const IconUnlimited: FC<IconUnlimitedProps> = ({
  size = nonThemeableRules.defaultSize as number as IconUnlimitedProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconUnlimitedProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M13.363 10.734c.914-1.148 2.235-2.062 3.793-2.062C19.316 8.672 21 10.164 21 12c0 1.836-1.684 3.328-3.844 3.328-4.215 0-4.672-6.656-10-6.656C5 8.672 3.11 10.164 3.11 12c0 1.836 1.891 3.328 4.051 3.328 1.996 0 3.262-.937 4.29-2.105'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconUnlimited
